import React from 'react'
import PropTypes from 'prop-types';

class Icon extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        style:  PropTypes.object,
        svg: PropTypes.string.isRequired
    }

    static defaultPropTypes = {
        style: {}
    }

    className = this.props.className ? ' ' + this.props.className : ''

    state = {
        className: this.props.className,
        style: this.props.style,
        svg: this.props.svg.replace(/(\r\n|\n|\r)/g, '')
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            ...nextProps,
            svg: nextProps.svg.replace(/(\r\n|\n|\r)/g, '')
        })
    }

    render() {
        const className = 'icon' + (this.state.className ? ' ' + this.state.className : '')

        return <div style={this.state.style} className={className} dangerouslySetInnerHTML={{__html: this.state.svg}} />
    }
}


export default Icon
